import { authRequest } from "@api/auth-requests";
import { AUTH_API_ROUTES } from "@constants/constants";
import { useMutation } from "@tanstack/react-query";
import { handleApiError } from "@utils/handle-api-error";
import type { AxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export interface ForgotPasswordRequest {
	email: string;
}

interface ForgotPasswordResponse {
	detail: string;
}

export async function forgotPassword({ email }: ForgotPasswordRequest) {
	const response = await authRequest
		.put<ForgotPasswordResponse>(AUTH_API_ROUTES.USER_RESET(email))
		.then((response) => response.data);
	return response;
}

export function useForgotPassword() {
	const { t } = useTranslation();

	const { mutate, isPending } = useMutation<
		ForgotPasswordResponse,
		AxiosError,
		ForgotPasswordRequest,
		unknown
	>({
		mutationFn: (args) => forgotPassword(args),
		onSuccess: () => {
			toast.success(t("notifications.forgot_password_sent"));
		},
		onError: (err) => {
			handleApiError(err);
		},
	});

	return {
		forgotPasswordMutate: mutate,
		forgotPasswordMutatePending: isPending,
	};
}
